import React, {FC} from 'react';
import {ListGroup} from 'components/ListGroup';

import TrashIconSrc from 'assets/icons/trash.svg';
import {Tag} from 'api/types/tagTypes';

import i18n from 'i18next';

type Props = {
  tags: Tag[];
  onDelete: (id: string) => void;
};

export const ExistingTagList: FC<Props> = props => {
  const tagListItems = props.tags.map(tag => {
    return (
      <div key={tag.id} className="flex items-center p-2">
        <h1 className="flex-grow pl-2">{tag.name}</h1>
        <img
          src={TrashIconSrc}
          alt={`${i18n.t('common.remove')} ${tag.name}`}
          className="cursor-pointer"
          onClick={() => props.onDelete(tag.id)}
        />
      </div>
    );
  });

  return <ListGroup items={tagListItems} />;
};
